import { J2UploadToCloud } from '@e3dc-react/icons'
import { Upload } from '@e3dc-react/shell/Elements/FileTransfer'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { DownloadsParent, UploadFileFormValues } from '../../models'
import DownloadItemForm from '../download-item-editor/DownloadItemForm'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { splitFileNameAndExtenstion } from 'src/Libs/downloads'

const useStyles = makeStyles()(theme => ({
  dropContext: {
    color: theme.palette.primary.main,
  },
  dropText: {
    color: theme.palette.grey.grey03,
  },
  icon: {
    fontSize: '3rem',
    marginBottom: theme.spacing(-2),
  },
  uploadBox: {
    padding: theme.spacing(4),
  },
}))

interface Props {
  parent: DownloadsParent
  setUploadedFile: React.Dispatch<React.SetStateAction<File | undefined>>
}

/**
 * Form for uploading files
 */
const UploadForm: React.FC<Props> = ({ parent, setUploadedFile }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  const { control, setValue } = useFormContext<UploadFileFormValues>()

  const fileNameField = useWatch({ name: 'fileName' })

  const onFileDropped = (file: File | undefined): void => {
    if (file) setValue('file', file, { shouldDirty: true, shouldValidate: true })
    if (file && fileNameField === '') {
      const { name } = splitFileNameAndExtenstion(file.name)
      setValue('fileName', name, { shouldDirty: true, shouldValidate: true })
      setValue('file', file, { shouldDirty: true, shouldValidate: true })
    }

    setUploadedFile(file)
  }

  return (
    <Stack direction={'column'} spacing={3} sx={{ mt: 2 }}>
      <Controller
        name="file"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <Upload
            {...field}
            content={
              <Box className={classes.uploadBox}>
                <J2UploadToCloud color="primary" className={classes.icon} />
                <Typography variant="h2" className={classes.dropContext}>
                  {t('documents.upload.context-text')}
                </Typography>
                <Typography variant="body1" className={classes.dropText}>
                  {t('documents.upload.drop-text')}
                </Typography>
              </Box>
            }
            onFilesDropped={onFileDropped}
            oneFile
            error={error ? (error.message as string) : undefined}
          />
        )}
      />
      <DownloadItemForm parent={parent} />
    </Stack>
  )
}

export default UploadForm
